// extracted by mini-css-extract-plugin
module.exports = {"home":"styles_home__DuhXN","row__extras":"styles_row__extras__Rvkwa","info":"styles_info___hYFP","section_featured_nft":"styles_section_featured_nft__Sh0Dp"};